import { urlWithParams } from "../../helpers/UrlHelpers";

const BASE_URL = process.env.REACT_APP_GH_MARKET_URL;
const DEFAULT_PARAMS = { order_by: 'id', order: 'desc' };

function bundlesPath(this: any, params: object = DEFAULT_PARAMS) {
  return urlWithParams(`/${this.basePath}/bundles`, params);
}
function bundlePath(this: any, id: number) {
  return `/${this.basePath}/bundles/${id}`;
}

const ghMarketUrls = {
  baseURL:      BASE_URL,
  basePath:     'gh_market',

  bundlesPath:  bundlesPath,
  bundlePath:   bundlePath,
}

export default ghMarketUrls;
